import { render, staticRenderFns } from "./Expansions.vue?vue&type=template&id=76a7e9e2&scoped=true"
import script from "./Expansions.vue?vue&type=script&lang=js"
export * from "./Expansions.vue?vue&type=script&lang=js"
import style0 from "./Expansions.vue?vue&type=style&index=0&id=76a7e9e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a7e9e2",
  null
  
)

export default component.exports